function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}

const DEDUP_MS = 5000;
let lastPushed = { key: null, at: 0 };

function shouldPushEvent(eventName, formId) {
    const key = `${eventName}|${formId ?? 'unknown'}`;
    const now = Date.now();
    if (lastPushed.key === key && now - lastPushed.at < DEDUP_MS) {
        return false;
    }
    lastPushed = { key, at: now };
    return true;
}

function getContactPopinFromEvent(event) {
    const target = event.target;
    if (!target?.closest) {
        return null;
    }
    const popin = target.closest('.c-form-popin');
    if (!popin || popin.getAttribute('data-popin-hash') !== 'contact') {
        return null;
    }
    return popin;
}

function getLangCodeFromPopin(popin) {
    const popinLang = popin?.getAttribute('data-lang');
    if (popinLang) {
        return popinLang.split('-')[0];
    }
    return (document.documentElement.getAttribute('lang') || 'en').split('-')[0];
}

function onContactFormMailSent(event) {
    const popin = getContactPopinFromEvent(event);
    if (!popin) {
        return;
    }

    const formRoot = popin.querySelector('.wpcf7');
    const detail = event.detail || {};
    const langCode = getLangCodeFromPopin(popin);
    const eventName = `contact_form_${langCode}_submitted`;
    const formId = detail.contactFormId ?? formRoot?.id ?? null;

    if (!shouldPushEvent(eventName, formId)) {
        return;
    }

    const payload = {
        event: eventName,
        form_id: formId,
        form_location: 'contact_popin',
        ...(detail.apiResponse && { response: detail.apiResponse }),
    };

    // GTM (GTM-5QTH3F9) déclenche GA4 + conversion Google Ads sur cet événement
    pushDataLayer(payload);
}

let initialized = false;

export function initContactFormTracking() {
    if (initialized) {
        return;
    }
    initialized = true;
    document.addEventListener('wpcf7mailsent', onContactFormMailSent, true);
}
